import { getTheme } from '@Thread-Magic/jasmine';
import TitleBar from 'frameless-titlebar';
import { useEffect, useState } from 'react';
import AppIcon from '../../assets/images/icon.png';
import { isMacintosh } from '../../utils';

// eslint-disable-next-line import/no-extraneous-dependencies
const remote = window.require('@electron/remote');
const currentWindow = remote.getCurrentWindow();

const DesktopTitleBar = () => {
  const theme = getTheme();
  const [maximized, setMaximized] = useState(currentWindow.isMaximized());
  useEffect(() => {
    const onMaximized = () => setMaximized(true);
    const onRestore = () => setMaximized(false);
    currentWindow.on('maximize', onMaximized);
    currentWindow.on('unmaximize', onRestore);
    return () => {
      currentWindow.removeListener('maximize', onMaximized);
      currentWindow.removeListener('unmaximize', onRestore);
    };
  }, []);

  const handleMaximize = () => {
    if (maximized) {
      currentWindow.restore();
    } else {
      currentWindow.maximize();
    }
  };

  return (
    <TitleBar
      iconSrc={isMacintosh() ? null : AppIcon}
      currentWindow={currentWindow}
      platform={process.platform}
      menu={null}
      theme={{
        bar: {
          palette: theme.isDark ? 'dark' : 'light',
          borderBottom: 'none',
          background: theme.colors.background.variant2,
          height: 38
        }
      }}
      title={isMacintosh() ? '' : 'Inbox'}
      onClose={() => currentWindow.close()}
      onMinimize={() => currentWindow.minimize()}
      onMaximize={handleMaximize}
      onDoubleClick={handleMaximize}
      disableMaximize={false}
      maximized={maximized}
    />
  );
};

export default DesktopTitleBar;
